<template>
  <v-hover v-slot="{ hover }" v-if="count > 0">
    <v-badge :value="count" color="white" class="black--text" overlap bordered offset-x="20">
      <template #badge>
        <span class="black--text font-weight-bold">
          {{ count }}
        </span>
      </template>
      <v-btn :loading="loading" @click="clickFn" class="ml-3" fab color="error">
        <v-icon size="32" v-if="hover">
          {{ icons.mdiRefresh }}
        </v-icon>
        <v-icon size="32" v-else>
          {{ icons.mdiBell }}
        </v-icon>
      </v-btn>
    </v-badge>
  </v-hover>
</template>

<script>
import Vue from "vue";

import { onMounted, ref, watch } from "@vue/composition-api";
import { postData } from "@utils";
import { useRouter } from "@core/utils";

import { useCallCenterStore } from "@/stores/callCenter";
import { mdiBell, mdiRefresh } from "@mdi/js";

import alarm from "@/assets/sound/alarm.mp3";
export default {
  setup() {
    const { route, router } = useRouter();
    const callCenterStore = useCallCenterStore();
    const audio = new Audio(alarm);

    const clickFn = () => {
      orderCount();
      if (route.value.name !== "call-center-list") {
        router.push({ name: "call-center-list" });
      }
    };

    const count = ref(0);
    const loading = ref(false);
    const orderCount = () => {
      loading.value = true;
      postData({
        method: "callCenterNewOrdCount",
      })
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error === 1) {
            throw new Error(response.msg);
          }

          count.value = response.count;

          if (count.value > 0) {
            callCenterStore.refreshList = !callCenterStore.refreshList;
            audio.play();
          }
        })
        .catch((e) => {
          // API hataya girdi
        })
        .finally(() => {
          // API işlemi bittikten sonra
          loading.value = false;
        });
    };
    watch(
      () => callCenterStore.isOrderStatusChange,
      () => {
        orderCount();
      }
    );

    setInterval(() => {
      //orderCount();
    }, 18000);

    onMounted(() => {
      orderCount();
    });

    return {
      clickFn,
      count,
      loading,
      icons: {
        mdiBell,
        mdiRefresh,
      },
    };
  },
};
</script>

<style></style>
